import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Runtime initialization: client will fetch `${API_BASE}/config` and call `initFirebase(config)`.
export const FIREBASE_ENABLED = false; // will be replaced at runtime after fetching `${API_BASE}/config`

let app: any = null;
let auth: any = null;
let db: any = null;
let googleProvider: any = null;
let appleProvider: any = null;

export async function initFirebaseFromRuntimeConfig(cfg: any) {
  if (!cfg || !cfg.firebase || !cfg.firebase.apiKey) {
    console.warn('Runtime Firebase config missing or incomplete, skipping init');
    return false;
  }

  try {
    app = getApps().length === 0 ? initializeApp(cfg.firebase) : getApp();
    auth = getAuth(app);
    db = getFirestore(app);
    googleProvider = new GoogleAuthProvider();
    appleProvider = new OAuthProvider('apple.com');
    console.log('Firebase initialized from runtime config', {
      projectId: cfg.firebase.projectId,
      authDomain: cfg.firebase.authDomain,
    });
    return true;
  } catch (err) {
    console.error('Failed to initialize Firebase from runtime config:', err);
    return false;
  }
}

export { auth, db, googleProvider, appleProvider };
export default app;
